import styled from 'styled-components'

export const FollowModalDimmer = styled.div`
  background: #000000;
  opacity: 0.5;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`

export const FollowModalCenterer = styled(FollowModalDimmer)`
  z-index: 1000;
  background: transparent;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const FollowModalWrapper = styled.div`
  position: relative;
  width: 50vw;
  max-width: 600px;
  height: 80vh;
  max-height: 1005px;
  background: white;
  border-radius: 16px;
  padding: 29px;
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 7px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 1000px) {
    width: 80vw;
    max-width: 800px;
  }

  @media screen and (max-width: 601px) {
    width: 100vw;
    height: 100vh;
    padding: 0;
    border-radius: 0;
  }
`

export const NavigationPanel = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  box-sizing: border-box;
`

export const TabsWrapper = styled.ul`
  width: 100%;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0;
  padding: 0;
  transition: 0.2s opacity ease-in-out;
  opacity: ${props => (props.visible ? 1 : 0)};
  margin-bottom: 22px;
  padding-top: 25px;
  padding-right: 22px;

  @media screen and (max-width: 601px) {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    justify-content: center;
    margin-bottom: 0;
    padding-right: 0;
  }
`

export const ActiveMarker = styled.div`
  content: '';
  width: 40px;
  height: 4px;
  background: black;
  margin-top: 15px;

  @media screen and (max-width: 601px) {
    height: 2px;
    width: 30px;
  }
`

export const Tab = styled.li`
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  opacity: ${props => (props.active ? '1' : '0.4')};
  cursor: pointer;

  ${ActiveMarker} {
    opacity: ${props => (props.active ? '1' : '0')};
  }

  &:not(:last-child) {
    margin-right: 60px;
  }

  @media screen and (max-width: 601px) {
    font-size: 16px;
    line-height: 16px;
  }
`

export const SearchField = styled.div`
  width: calc(100% - 24px);
  height: 46px;
  background: #f5f5f5;
  border-radius: 64px;
  display: flex;
  align-items: center;
  margin-bottom: 27px;

  @media screen and (max-width: 601px) {
    width: calc(100% - 32px);
    margin-left: 17px;
    margin-right: 15px;
    margin-bottom: 14px;
  }
`

export const SearchFieldInput = styled.input`
  border: none;
  background: transparent;
  height: 100%;
  width: 100%;
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.01em;
  color: black;
  padding: 0 19px;
  box-sizing: border-box;
`

export const Icon = styled.img`
  margin-right: 18px;
`

export const DesignersContent = styled.div`
  flex: 1;
  overflow: auto;

  @media screen and (max-width: 601px) {
    padding-top: 27px;
  }
`

export const CloseModal = styled.img`
  width: 19px;
  height: 19px;
  position: absolute;
  top: 22px;
  right: 22px;
  cursor: pointer;

  @media screen and (max-width: 601px) {
    top: 16px;
    left: 8px;
    width: 36px;
    height: 36px;
  }
`

export const UserLine = styled.div`
  display: flex;
  flex-diretion: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 21px;
  padding-right: 23px;

  @media screen and (max-width: 601px) {
    padding-right: 15px;
    padding-left: 17px;
  }
`

export const UserProfilePart = styled.div`
  display: flex;
  flex-direction: row;
`

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px 14px 5px;
`

export const Username = styled.span`
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #000000;

  @media screen and (max-width: 601px) {
    max-width: 145px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`

export const TimeAgo = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.01em;
  color: #8b8b8b;
`
